<template>
  <div id="mypage-individualInfo-template" class="content-inner-fix" >
    <!-- BEGIN content-section -->
    <div class="content-section">
      <div class="table-wrap mt-0">
        <table class="table-body-only">
          <caption class="ir-text">회원가입 정보입력</caption>
          <colgroup class="pc-cell">
            <col style="width: 160px" />
            <col />
          </colgroup>
          <colgroup class="mo-cell">
            <col style="width: 88px" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row">아이디</th>
              <td>{{member.loginid}}</td>
            </tr>
            <tr>
              <th scope="row">대표<br class="mo-only">이메일</th>
              <td>
                <div class="input-group email-group">
                  <div class="items1">
                    <div class="input-area wid200">
                      <input type="text" name="" v-model="email1" placeholder="1234" title="1234">
                    </div>
                    <div class="dash">@</div>
                  </div>
                  <div class="items2">
                    <div class="input-area wid200">
                      <select title="이메일 계정 선택" id="emailSelectBox" v-model="email2" v-on:change="emailChange">
                        <option v-for="list in emailList" :value="list">{{list}}</option>
                        <option value="etc">직접입력</option>
                      </select>
                    </div>
                    <div class="input-area wid200">
                      <input type="text" id="emailSelectBoxDirect" style="display: none;" v-model="etcEmailAddress" placeholder="email.com" title="email.com">
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">이름</th>
              <td>{{member.name}}</td>
            </tr>
            <tr>
              <th scope="row">비밀번호</th>
              <td>
                <a href="mypage-password.do" class="btn btn-gray btn-md">
                  비밀번호 변경
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="subpage-tit2 mt-40">기업정보</div>
      <div class="table-wrap">
        <table class="table-body-only">
          <caption class="ir-text">기업정보수정 표</caption>
          <colgroup class="pc-cell">
            <col style="width: 160px" />
            <col />
          </colgroup>
          <colgroup class="mo-cell">
            <col style="width: 88px" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row">사업자<br class="mo-only">등록번호</th>
              <td>123-45-68790</td>
            </tr>
            <tr>
              <th scope="row">기업명</th>
              <td>길동 주식회사</td>
            </tr>
            <tr>
              <th scope="row">기업<br class="mo-only">구분</th>
              <td>본사</td>
            </tr>
            <tr>
              <th scope="row">지사<br class="mo-only">(지점)명</th>
              <td>-</td>
            </tr>
            <tr>
              <th scope="row">업종</th>
              <td>
                <div class="input-group industry">
                  <div class="input-area">
                    <input type="text" placeholder="선택"  title="업종"/>
                  </div>
                  <button type="button" class="btn btn-primary btn-xsm">
                    업종 검색
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">주요<br class="mo-only">사업<br class="mo-only">내용<span class="must">*</span></th>
              <td>
                <div class="input-area wid100p">
                  <input type="text" placeholder="선택"  title="주요 사업내용"/>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">설립<br class="mo-only">연월 <span class="must">*</span></th>
              <td>
                <div class="input-area wid160">
                  <input type="date" max="9999-12-31" placeholder="선택" title="설립 연월"/>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">근로자수 </th>
              <td>
                <div class="input-group total-member">
                  <div class="input-area wid72 total">
                    <input type="text" placeholder=""  title="근로자 수"/>
                  </div>
                  명 <br class="mo-only">
                  (여<div class="input-area wid72"><input type="text" placeholder="" title="명 / 입력" /></div>명 /
                  남<div class="input-area wid72"><input type="text" placeholder="" title="명) 입력" /></div>명)
                </div>
                <div class="note-text">* 값이 없는경우: <span>0</span> 명</div>
              </td>
            </tr>
            <tr>
              <th scope="row">상장<br class="mo-only">여부</th>
              <td>
                <div class="flex gap10">
                  <label class="radio-item">
                    <input type="radio" name="education" value="all" checked="" aria-label="상장 여부, 상장">
                    <span class="custom-radio"></span>
                    상장
                  </label>
                  <label class="radio-item">
                    <input type="radio" name="education" value="none" aria-label="상장 여부, 비상장">
                    <span class="custom-radio"></span>
                    비상장
                  </label>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">4대보험  <br class="mo-only">가입</th>
              <td>
                <div class="flex gap10 insulan-check">
                  <div class="check-wrap"><input type="checkbox" id="insurance01" title="국민연금 선택"><label for="insurance01"><span>국민연금</span></label></div>
                  <div class="check-wrap"><input type="checkbox" id="insurance02" title="고용보험 선택"><label for="insurance02"><span>고용보험</span></label></div>
                  <div class="check-wrap"><input type="checkbox" id="insurance03" title="산재보험 선택"><label for="insurance03"><span>산재보험</span></label></div>
                  <div class="check-wrap"><input type="checkbox" id="insurance04" title="건강보험 선택"><label for="insurance04"><span>건강보험</span></label></div>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">기업유형</th>
              <td>
                <div class="flex gap10 mo-derection">
                  <label class="radio-item">
                    <input type="radio" name="company" value="type1" checked="" aria-label="기업유형, 공공">
                    <span class="custom-radio"></span>
                    공공
                  </label>
                  <label class="radio-item">
                    <input type="radio" name="company" value="type2" aria-label="기업유형, 민간">
                    <span class="custom-radio"></span>
                    민간
                  </label>
                  <label class="radio-item">
                    <input type="radio" name="company" value="type3" aria-label="기업유형, 기타법인 및 단체">
                    <span class="custom-radio"></span>
                    기타법인 및 단체
                  </label>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">대표 전화번호 <span class="must">*</span></th>
              <td>
                <div class="input-group phone-group">
                  <div class="items1">
                    <div class="input-area wid120">
                      <select title="대표 전화번호 지역번호 선택">
                        <option>02</option>
                      </select>
                    </div>
                    <div class="dash">-</div>
                  </div>
                  <div class="items2">
                    <div class="input-area wid120">
                      <input type="text" placeholder="1234" title="대표전화번호 중간자리">
                    </div>
                    <div class="dash">-</div>
                    <div class="input-area wid120">
                      <input type="text" placeholder="1234" title="대표전화번호 뒷자리">
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">팩스</th>
              <td>
                <div class="input-group phone-group">
                  <div class="items1">
                    <div class="input-area wid120">
                      <select title="팩스 지역번호 선택">
                        <option>02</option>
                      </select>
                    </div>
                    <div class="dash">-</div>
                  </div>
                  <div class="items2">
                    <div class="input-area wid120">
                      <input type="text" placeholder="1234" title="팩스 번호 중간자리">
                    </div>
                    <div class="dash">-</div>
                    <div class="input-area wid120">
                      <input type="text" placeholder="1234" title="팩스 번호 뒷자리">
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">주소</th>
              <td>
                <div class="address-wrap">
                  <div class="input-group post-code">
                    <div class="input-area wid200">
                      <input type="text" placeholder="" title="우편번호">
                    </div>
                    <button type="button" class=" btn btn-primary btn-xsm">
                      우편번호 검색
                    </button>
                  </div>
                  <div class="input-group add-input">
                    <div class="input-area wid400">
                      <input type="text" disabled placeholder="" title="기본주소">
                    </div>
                    <div class="input-area wid400">
                      <input type="text" placeholder="" title="상세주소">
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="subpage-tit2 mt-40">부가정보</div>
      <div class="table-wrap">
        <table class="table-body-only">
          <caption class="ir-text">기업정보수정 표</caption>
          <colgroup class="pc-cell">
            <col style="width: 160px" />
            <col />
          </colgroup>
          <colgroup class="mo-cell">
            <col style="width: 88px" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row">홈페이지</th>
              <td>
                <div class="input-group">
                  http://
                  <div class="input-area wid400">
                    <input type="text" disabled placeholder="" title="홈페이지 주소">
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="subpage-tit2 mt-40">선택사항</div>
      <div class="table-wrap">
        <table class="table-body-only">
          <caption class="ir-text">기업정보수정 표</caption>
          <colgroup class="pc-cell">
            <col style="width: 160px" />
            <col />
          </colgroup>
          <colgroup class="mo-cell">
            <col style="width: 88px" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row">E-mail <br class="mo-only">수신</th>
              <td>
                <div class="flex gap10">
                  <label class="radio-item" v-for="(key, value) in emailCheck">
                    <input type="radio" name="inlineRadioOptions1" :id="'emailChk_' + value" v-model="member.emailCheck" :value="value" :aria-label="'E-mail 수신 여부, ' + key">
                    <span class="custom-radio"></span>{{key}}
                  </label>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">SMS <br class="mo-only">수신</th>
              <td>
                <div class="flex gap10">
                  <label class="radio-item" v-for="(key, value) in smsCheck">
                    <input type="radio" name="inlineRadioOptions2" :id="'smsCheck_' + value" v-model="member.smsCheck" :value="value" :aria-label="'SMS 수신 여부, ' + key">
                    <span class="custom-radio"></span>
                    {{key}}
                  </label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="button-area flex-justify-between mo-button-full mt-32">
        <div>
          <a href="#" class="btn btn-secondary btn-md" @click="showWithdrewModal" title="탈퇴하기">탈퇴하기</a>
        </div>
        <form id="myEduForm" name="myEduForm" method="post" action="/slMemberLinkReqCancel">
          <input type="hidden" name="instCd" id="instCd" value="B55366"/><!-- 평생학습포털 서울런4050 행정표준기관 코드 -->
        </form>
        <withdrew-modal :showModal.sync="showModal"></withdrew-modal>
        <div>
          <a href="#" class="btn btn-primary btn-md" @click="updateInfo" title="수정하기">
            <i class="ico ico-pen-wt"></i>
            수정하기
          </a>
        </div>
      </div>
    </div>
  </div>
  <!-- END content-section -->
</template>
<script>
  /* global daum */
  import Axios from 'axios';
  import WithdrewModal from './WithdrewModal.vue';

  const occuList = [
    '경영/금융/사무/보험',
    '공무원(교사)',
    '교육/강사/연구/법률',
    '의료/보건/사회복지',
    '마케팅/무역',
    '전문직(의사/변호사 등)',
    '문화/예술/신문방송/디자인',
    '영업/판매/고객상담/CS',
    '건설/건축/환경/산업',
    'IT/정보통신/웹',
    '숙박/음식/여행/스포츠/경비청소',
    '전업주부',
    '무직',
    '기타',
  ];

  const gender = {
    M: '남성',
    F: '여성',
  };

  const emailCheck = {
    Y: '수신',
    N: '거부',
  };

  const smsCheck = {
    Y: '수신',
    N: '거부',
  };

  const emailList = [
    'naver.com',
    'hanmail.net',
    'daum.net',
    'gmail.com',
    'google.com',
    'nate.com',
    'yahoo.com',
    'paran.com',
    'korea.com',
    'freechal.com',
  ];


  const joinPurpose = [
    '인생후반전 준비에 대한 인식을 가지고자',
    '사회공헌 및 자원봉사에 관심이 있어서',
    'NGO 등 인생후반전을 위한 단체를 구성하기 위해서',
    '창업을 위해서',
    '재취업을 위해서',
    '생각이나 취미가 같은 사람들을 만나기 위해',
  ];
  const applyPath = [
    '서울시 유관홈페이지',
    '언론보도',
    '홍보책자',
    '옥외광고',
    '미디어광고',
    '인터넷/SNS 검색',
    '타 기관 안내',
    '50+재단/캠퍼스/센터',
    '지인소개',
  ];
  export default {
    name: 'mypage-myinfo-template',
    props: ['member', 'orgList', 'orgCode'],
    components: {
      WithdrewModal,
    },
    data() {
      return {
        emailList,
        joinPurpose,
        applyPath,
        etcEmailAddress: '',
        allCheck: false,
        motive: '',
        channel: '',
        email1: '',
        showModal: false,
        email2: '',
        channelEtc: '',
        motiveEtc: '',
        gender,
        occuPation: [],
        occuPationStr: '',
        occuList,
        occuEtcVal: '',
        emailCheck,
        smsCheck,
      };
    },
    computed: {

    },
    watch: {
    },
    methods: {
      checked(event) {
        if (event.key === "'") {
          alert("'는 사용 하실 수 없습니다.");
          this.channelEtc = this.channelEtc.replace("'", '');
          this.motiveEtc = this.motiveEtc.replace("'", '');
          this.occuEtcVal = this.occuEtcVal.replace("'", '');
          this.member.addr2 = this.member.addr2.replace("'", '');
        }
      },
      onClick(obj) {
        if (this.occuPationStr === obj) {
          this.member.occuPation = [];
          this.occuPation = [];
          this.occuPationStr = '';
        } else {
          this.member.occuPation = [obj];
          this.occuPation = [obj];
          this.occuPationStr = obj;
        }
      },
      updateInfo() {
        if (!this.email2 || !this.email1) {
          alert('이메일을 입력해 주세요.');
        } else if (!this.member.phone1 || !this.member.phone2 || !this.member.phone3) {
          alert('연락처를 입력해 주세요.');
        } else if (!this.member.zipcode || !this.member.addr1 || !this.member.addr2) {
          alert('주소를 입력해 주세요.');
        } else if (!this.channel || (this.channel === 'etc' && !this.channelEtc)) {
          alert('가입경로를 입력해 주세요.');
        } else if (!this.motive || (this.motive === 'etc' && !this.motiveEtc)) {
          alert('가입동기 및 희망분야를 입력해 주세요.');
        } else if (this.member.likeOrgs.length === 0) {
          alert('나의 관심 50+를 최소 한 개의 선택이 필요합니다.');
          $('#like-orgs').focus();
        } else if (!this.member.emailCheck) {
          alert('이메일 수신여부를 선택해주십시오.');
        } else if (!this.member.smsCheck) {
          alert('문자메시지 수신여부를 선택해주십시오.');
        } else {
          const email2 = this.email2 !== 'etc' ? this.email2 : this.etcEmailAddress;
          const channel = this.channel !== 'etc' ? this.channel : this.channelEtc;
          const motive = this.motive !== 'etc' ? this.motive : this.motiveEtc;
          const mail = `${this.email1}@${email2}`;
          const etc = this.occuPationStr.substring(0, 2);
          if (etc === '기타') {
            const front = '기타(';
            const end = ')';
            this.occuPationStr = front + document.getElementById('occuEtc').value + end;
            this.occuEtcVal = document.getElementById('occuEtc').value;
          }
          if (this.occuPationStr === '') {
            this.occuPationStr = this.member.occuPation.toString();
          }

          const Params = {
            email: mail,
            birthdate: this.member.birthdate,
            phone1: this.member.phone1,
            phone2: this.member.phone2,
            phone3: this.member.phone3,
            zipcode: this.member.zipcode,
            addr1: this.member.addr1,
            addr2: this.member.addr2,
            gender: this.member.gender,
            applyPath: channel,
            joinPurpose: motive,
            likeOrgs: this.member.likeOrgs,
            photoSignUrl: this.member.photoSignUrl,
            photoUrl: this.member.photoUrl,
            occuPation: this.occuPationStr,
            emailCheck: this.member.emailCheck,
            smsCheck: this.member.smsCheck,
          };
          Axios.put('/api/members/info', Params).then(() => {
            alert('저장되었습니다.');
            location.reload();
          }).catch((e) => {
            alert(e.response.data.msg);
          });
        }
      },
      imgSignUrlChange() {
        $('#signform').ajaxSubmit({
          dataType: 'json',
          error: (err) => {
            alert(err.msg);
          },
          success: (response, statusText, xhr) => {
            if (xhr.status === 401) {
              alert('로그아웃 상태입니다.');
              location.href = '/login.do';
            } else if (xhr.status < 400) {
              this.member.photoSignUrl = response.filename;
              if (response.filename === 'false') {
                alert('사진의 가로와 세로 길이를 확인해 주세요.');
                document.getElementById('mySign').value = '';
                this.member.photoSignUrl = '';
              } else {
                this.member.photoSignUrl = response.filename;
              }
            } else {
              alert(statusText);
            }
          },
        });
      },
      imgUrlChange() {
        const that = this;
        $('#profileform').ajaxSubmit({
          dataType: 'json',
          error: (err) => {
            alert(err.msg);
          },
          success: (response, statusText, xhr) => {
            if (xhr.status === 401) {
              alert('로그아웃 상태입니다.');
              location.href = '/login.do';
            } else if (xhr.status < 400) {
              that.member.photoUrl = response.filename;
            } else {
              alert(statusText);
            }
          },
        });
      },
      motiveValue() {
        const purpose = this.joinPurpose.filter(item => item === this.member.joinPurpose);
        if (purpose && purpose.length > 0) {
          this.motive = this.member.joinPurpose;
        } else {
          this.motive = 'etc';
          this.motiveEtc = this.member.joinPurpose;
        }
      },
      channelValue() {
        const route = this.applyPath.filter(item => item === this.member.applyPath);
        if (route && route.length > 0) {
          this.channel = this.member.applyPath;
        } else {
          this.channel = 'etc';
          this.channelEtc = this.member.applyPath;
        }
      },
      emailValue() {
        this.email1 = this.member.email.split('@')[0];
        const emailAddress = this.member.email.split('@')[1];
        let isSame = false;
        emailList.forEach((item) => {
          if (item === emailAddress) isSame = true;
          else if (item !== emailAddress) {
            this.etcEmailAddress = emailAddress;
          }
        });
        if (isSame) this.email2 = emailAddress;
        else this.email2 = 'etc';
      },
      emailChange() {
        if (this.email2 === 'etc') {
          document.getElementById('emailSelectBoxDirect').style.display = 'block';
        } else {
          document.getElementById('emailSelectBoxDirect').style.display = 'none';
        }
      },
      channelChange() {
        if (this.channel === 'etc') {
          document.getElementById('joinChannelEtc').style.display = 'block';
        } else {
          document.getElementById('joinChannelEtc').style.display = 'none';
        }
      },
      chkAllOrgs() {
        if (this.allCheck) {
          this.orgCode.forEach((item) => {
            this.member.likeOrgs.push(item);
          });
        } else {
          this.member.likeOrgs = [];
        }
      },
      foldDaumPostcode() {
        const elementWrap = document.getElementById('wrap');
        // iframe을 넣은 element를 안보이게 한다.
        elementWrap.style.display = 'none';
      },
      findAddress() {
        const thisVal = this;
        const elementWrap = document.getElementById('wrap');
        // 현재 scroll 위치를 저장해놓는다.
        const currentScroll = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
        daum.postcode.load(() => {
          new daum.Postcode({
            oncomplete(data) {
              // 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

              // 각 주소의 노출 규칙에 따라 주소를 조합한다.
              // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
              let fullAddr = data.address; // 최종 주소 변수
              let extraAddr = ''; // 조합형 주소 변수

              // 기본 주소가 도로명 타입일때 조합한다.
              if (data.addressType === 'R') {
                // 법정동명이 있을 경우 추가한다.
                if (data.bname !== '') {
                  extraAddr += data.bname;
                }
                // 건물명이 있을 경우 추가한다.
                if (data.buildingName !== '') {
                  extraAddr += (extraAddr !== '' ? `,${data.buildingName}` : data.buildingName);
                }
                // 조합형주소의 유무에 따라 양쪽에 괄호를 추가하여 최종 주소를 만든다.
                fullAddr += (extraAddr !== '' ? `(${extraAddr})` : '');
              }

              // 우편번호와 주소 정보를 해당 필드에 넣는다.
              // 5자리 새우편번호 사용
              // document.getElementById('postcode').value = data.zonecode;
              thisVal.member.addr1 = fullAddr;
              thisVal.member.zipcode = data.zonecode;

              // iframe을 넣은 element를 안보이게 한다.
              // (autoClose:false 기능을 이용한다면, 아래 코드를 제거해야 화면에서 사라지지 않는다.)
              elementWrap.style.display = 'none';

              // 우편번호 찾기 화면이 보이기 이전으로 scroll 위치를 되돌린다.
              document.body.scrollTop = currentScroll;
            },
            // 우편번호 찾기 화면 크기가 조정되었을때 실행할 코드를 작성하는 부분. iframe을 넣은 element의 높이값을 조정한다.
            onresize(size) {
              elementWrap.style.height = `${size.height}px`;
            },
            width: '100%',
            height: '100%',
          }).embed(elementWrap);
        });
        // iframe을 넣은 element를 보이게 한다.
        elementWrap.style.display = 'block';
      },
      showWithdrewModal() {
        $('body').addClass('modal-open');
        this.showModal = true;
      },
      occuPationEtc() {
        const str = this.member.occuPation.toString();
        const etc = str.substring(0, 2);
        if (etc === '기타') {
          const left = str.indexOf('(');
          const right = str.indexOf(')');
          const sub = str.substring(left, right);
          const len = sub.length;
          const subPlus = sub.substring(1, len);
          document.getElementById('occuEtc').value = subPlus;
          this.occuEtcVal = subPlus;
          this.member.occuPation = [etc];
          this.occuPationStr = etc;
        }
      },
      slCan() {
        const result = window.confirm('서울시평생학습포털 회원정보와 연계를 철회하시겠습니까?');
        if (result) {
          $('#myEduForm').ajaxSubmit({
            dataType: 'json',
            error: (err) => {
              alert(err.msg);
            },
            success: (response, statusText) => {
              if (statusText === 'success') {
                alert('연계가 철회 되었습니다.');
              }
            },
          });
        }
      },
    },
    mounted() {
      this.emailValue();
      this.motiveValue();
      this.channelValue();
      this.channelChange();
      this.emailChange();
      this.occuPationEtc();
    },
  };
</script>



// WEBPACK FOOTER //
// CompInfo.vue?1e8ddc7e